"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastReceipt = void 0;
const lastReceipt = (reservation) => {
    const dateOrderedReceipts = reservation.payment.receipts.sort((a, b) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
    if (dateOrderedReceipts.length > 0) {
        return dateOrderedReceipts[0];
    }
    return null;
};
exports.lastReceipt = lastReceipt;
//# sourceMappingURL=lastReceipt.js.map